/*
 * (c) Meta Platforms, Inc. and its affiliates.
 */

import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { AiFillCheckCircle, AiFillMinusCircle } from "react-icons/ai";

const EXCLUDED_KEYS = ["url", "image_id", "id"];

export default function Modal({ modalOpen, setOpenModal, data }: any) {
	/**
	 * Format the data from 1's and 0's into icons
	 * for better visualization.
	 * @param entry
	 * @returns
	 */
	const formatBinaryResponse = (entry: string) => {
		switch (true) {
			case entry === "0" || entry === "0.0":
				return <AiFillMinusCircle color="#F67665" />;
			case entry === "1" || entry === "1.0":
				return <AiFillCheckCircle color="#36D399" />;
			default:
				return entry;
		}
	};

	const DataToDisplay: React.FC | any = () => {
		if (!data) return <></>;
		return Object.entries(data).map((i, index) =>
			!EXCLUDED_KEYS.includes(i[0]) ? (
				<div className="px-1 lg:px-2 py-0 grid grid-cols-2 gap-2" key={index}>
					<dt className="text-[10px] font-medium text-gray/70">{i[0]}</dt>
					<dd className="mt-1 text-[10px] sm:mt-0 text-left text-white">
						{formatBinaryResponse(i[1] as string)}
					</dd>
				</div>
			) : (
				<></>
			)
		);
	};

	return (
		<>
			{modalOpen ? (
				<React.Fragment>
					<div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
						<div className="relative w-auto my-6 mx-auto lg:max-w-4xl max-h-[60vh]">
							{/*content*/}
							<div className="flex flex-col md:flex-row border-0 rounded-lg shadow-lg relative w-full bg-black outline-none focus:outline-none">
								<div
									className="absolute top-2 right-2 p-2 cursor-pointer z-[100] text-white"
									onClick={() => setOpenModal(false)}
								>
									<AiFillCloseCircle />
								</div>
								<div className="flex-auto w-full md:w-3/5 p-4 lg:p-0 m-auto">
									<img className="mx-auto" src={data.url} alt="" />
								</div>

								<div className="relative p-6 flex-auto w-full md:w-2/5">
									<p className="my-4 text-slate-500 text-lg leading-relaxed">
										<DataToDisplay />
									</p>
								</div>
							</div>
						</div>
					</div>
					{/*overlay*/}
					<div className="opacity-50 fixed inset-0 z-40 bg-black"></div>
				</React.Fragment>
			) : null}
		</>
	);
}
